
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/snerapport-vurderinger",
      function () {
        return require("private-next-pages/[region]/[resort]/snerapport-vurderinger.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/snerapport-vurderinger"])
      });
    }
  